import { request } from './index';
import Formatters from '@/utils/Formatters'; 
import currentUser from '@/utils/currentUser'; 
import axios from '@/axios';

export async function getLogs(item, page, itemsPerPage) { 
    try {
      const { data } = await axios.get(`/history_logs`, { params: {
        date_initial: item.date_initial ?? '',
        date_final: item.date_final ?? '',
        hospital: item.hospital,
        user_cpf: item.cpf ? Formatters.removeNonNumeric(item.cpf) :  '',
        page,
        per_page: itemsPerPage
      }});

        return data
    }catch (error){
        return error  
    }
}

async function fetchDonorFilter(params = {}, unity) {
  const userData = currentUser.getUserData()
  try { 
    if(!userData.abilities.includes('list_all_unities')) {
      params.unity = unity;
    }

    const { data } = await axios.get(`/donor/filter`, { params });
      return data.data;

  }catch(error){
    return error;
  }
}

export async function getMePatients(unity, store) {
  return fetchDonorFilter({ kind_of_donor: '1' }, unity, store);
}

export async function getPcrPatients(unity, store) {
  return fetchDonorFilter({ kind_of_donor: '2' }, unity, store);
}

export async function getFinishedTransplants(unity, store) {
  return fetchDonorFilter({ status: '22' }, unity, store);
}

export async function getPendingTransplants(unity, store) {
  try {
    let data = await fetchDonorFilter({ status: '' }, unity, store); 
    return data.filter(x => x.donor_status.slug != 'doacao-efetivada');
  } catch (error) {
    return error;
  }
}

export async function getUnities() {
    return await request("GET", "/unities")
}